<ng-template let-row="row" let-value="value">
    <div
        class="d-flex align-items-center overflow-hidden"
        [tippy]="value.data.join('<br />')"
        [lazy]="true"
        variation="hint">
        <span>{{value.data.join(', ')}}</span>
    </div>
</ng-template>
